import { render, staticRenderFns } from "./Propose.vue?vue&type=template&id=27d9e1fc&scoped=true&"
import script from "./Propose.vue?vue&type=script&lang=js&"
export * from "./Propose.vue?vue&type=script&lang=js&"
import style0 from "./Propose.vue?vue&type=style&index=0&id=27d9e1fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d9e1fc",
  null
  
)

export default component.exports